import { render, staticRenderFns } from "./HelpItem.vue?vue&type=template&id=2cc001a0&"
import script from "./HelpItem.vue?vue&type=script&lang=js&"
export * from "./HelpItem.vue?vue&type=script&lang=js&"
import style0 from "./HelpItem.vue?vue&type=style&index=0&id=2cc001a0&prod&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.14_webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports